<template>
  <nav>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType"
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-row>
      <v-col :cols="mobile() ? '12' : '11'" class="mx-auto pb-0">
        <v-btn
          color="darktext"
          class="rounded-xxl text-none white--text px-4"
          @click="goBack"
        >
          <v-icon>mdi-chevron-left</v-icon>{{ $t('backToHub') }}
        </v-btn>
        
        <span
          class="float-right"
        >
          <v-menu
            v-if="mobile()"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class=" px-5 py-2"
                height="100%"
                icon
                v-bind="attrs"
                v-on="on"
              >
                <v-icon large>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list
              class="menulist-drawer"
              data-testid="menu-list"
            >
              <v-list-item
                :class="{'v-list-item--active': $route.name === 'HubOverview'}"
                @click="showHubOverview"
              >
                <v-list-item-title>{{ $t('overview') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                :class="{'v-list-item--active': $route.name === 'PeopleInHub'}"
                @click="showHubMembers"
              >
                <v-list-item-title>{{ $t('people') }}</v-list-item-title>
              </v-list-item>
              <v-list-item
                class="accent--text"
                :class="{'v-list-item--active': $route.name === 'BoostersInHub'}"
                @click="showHubOwners"
              >
                <v-list-item-title>{{ $t('owners') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </span>
        <p class="text-h5 font-weight-bold pt-5" :align="mobile() ? 'center' : 'left'">
          {{ $t('peopleInHubTitle') }}
        </p>
        <p class="text-body-1 greytext--text d-none d-md-block">
          {{ $t('peopleInHubText') }}
        </p>
      </v-col>
      <v-col
        v-if="!mobile()"
        cols="11"
        class="mx-auto custom-tab-menu py-0"
      >
        <v-list
          class="py-0"
          flat
        >
          <v-list-item
            :class="{'v-list-item--active': $route.name === 'HubOverview'}"
            @click="showHubOverview"
          >
            {{ $t('overview') }}
          </v-list-item>          
          <v-list-item
            :class="{'v-list-item--active': $route.name === 'PeopleInHub'}"
            @click="showHubMembers"
          >
            {{ $t('people') }}
          </v-list-item>
          <v-list-item
            class="accent--text"
            :class="{'v-list-item--active': $route.name === 'BoostersInHub'}"
            @click="showHubOwners"
          >
            {{ $t('owners') }}
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="11" class="mx-auto pt-2 pb-0">
          <SearchBarExpanding v-if="totalUsers > 0" @input="searchPeople" @resetSearch="resetSearch"/>
      </v-col>
    </v-row>
    <v-row
      v-if="(!users || users.length == 0) && usersInfo.currentPage == 1 && !loadingData && search == null"
      align="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="6"
        offset-sm="2"
        offset-md="3"
        align="center"
      >
        <EmptyPage
          :page-title="$t('emptyPeopleInHubTitle')"
          :page-text="$t('emptyPeopleInHubText')"
          page-image="image1"
        />
      </v-col>
    </v-row>

    <v-row
      v-else
      align="center"
      class="mx-auto"
      :class="mobile() ? 'pa-3' : ''"
    >
      <v-col
        :cols="mobile() ? '12' : '11'"        
        class="mx-auto px-0"
      >
        <v-card
          v-for="user in users"
          :key="user.id"
          rounded="xxl"
          class="my-2 solo"
        >
          <v-hover v-if="mobile()">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-3 elevation-${hover? 8 : 2 }`"
            >
            <v-col 
                cols="11"
                class="d-flex justify-left align-center "
              >
                <v-avatar
                  size="38"
                  class="ml-4 mr-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  />
                  <img v-else :src="`${user.attributes.avatar_thumb}`" />
                </v-avatar>
                <div class="mail-name text-no-wrap text-truncate mr-4">
                  <v-card-text class="text-body-2 darktext--text pa-0 text-no-wrap text-truncate d-block">
                    {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                  </v-card-text>
                  <v-card-text class="text-body-3 greytext--text pa-0 text-no-wrap text-truncate">
                    {{ user.attributes.email }} 
                  </v-card-text>
                </div>
              </v-col>
              <v-col
                cols="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  v-if="userId != user.id && spaceOwnerEmail != user.attributes.email"
                  offset-y
                  flat
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-1"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      data-testid="remove-user-from-hub"
                      router 
                      @click.stop="
                        selectedUserForRemoving= user.attributes.email,
                        dialogVisibleRemoveUser=true, 
                        confirmationDialogTitle=$t('confirmationDialogTitleRemoveUserFromHub'),
                        confirmationDialogText=$t('confirmationDialogTextRemoveOwnerFromHub'),
                        confirmationDialogSubmitBtn=$t('remove')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('remove') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
          <v-hover v-if="!mobile()">
            <v-row
              slot-scope="{ hover }"
              no-gutters
              :class="`py-4 elevation-${hover? 8 : 2 }`"
            >
              <v-col
                md="1"
                align="center"
                class="d-flex justify-center align-center"
              >
                <v-avatar
                  size="38"
                  class="mx-2"
                >
                  <img
                    v-if="user.attributes.avatar_thumb == null"
                    :src="defaultImage"
                  >
                  <img
                    v-else
                    :src="`${user.attributes.avatar_thumb}`"
                  >
                </v-avatar>
              </v-col>

              <v-col
                md="5"
                align="left"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('name') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.first_name }} {{ user.attributes.last_name }}
                </div>
              </v-col>

              <v-col
                md="5"
                align="left"
                class="pl-2"
              >
                <div class="text-body-2 grey--text justify-left">
                  {{ $t('mail') }}
                </div>
                <div class="text-body-1 darktext--text">
                  {{ user.attributes.email }}
                </div>
              </v-col>

              <v-col
                md="1"
                class="text-right d-flex align-center justify-end three-dots"
              >
                <v-menu
                  v-if="userId != user.id && spaceOwnerEmail != user.attributes.email"
                  offset-y
                  flat
                  bottom
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mr-4"
                      icon
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon
                        data-testid="threedots-icon"
                        x-large
                      >
                        mdi-dots-vertical
                      </v-icon>
                    </v-btn>
                  </template>
                  <v-list data-testid="menu-list-user">
                    <v-list-item
                      data-testid="remove-user-from-hub"
                      router 
                      @click.stop="
                        selectedUserForRemoving= user.attributes.email,
                        dialogVisibleRemoveUser=true, 
                        confirmationDialogTitle=$t('confirmationDialogTitleRemoveUserFromHub'), 
                        confirmationDialogText=$t('confirmationDialogTextRemoveOwnerFromHub'), 
                        confirmationDialogSubmitBtn=$t('remove')
                        confirmationDialogCancelBtn=$t('no')"
                    >
                      <v-list-item-title> {{ $t('remove') }} </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
            </v-row>
          </v-hover>
        </v-card>
      </v-col>
    </v-row>
    <Pagination
      v-if="users.length > 0"
      v-model="pageNumber"
      class="mb-16"
      circle
      :data-length="usersInfo.total"
      :page-number="usersInfo.currentPage"
      total-visible="5"
      :size="size"
      @input="handlePageChange"
      :key="paginationKey"
    />
    <ConfirmationDialog
      v-if="dialogVisibleRemoveUser"
      ref="confirmationDialogRemoveUser"
      :visible="dialogVisibleRemoveUser"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      data-testid="confirmation-dialog-user" 
      @close="dialogVisibleRemoveUser=false"
      @proceedSubmit="removeUser(selectedUserForRemoving)"
    />
    <PlusButtonWithLink
      data-testid="add-boosters-button"
      rounded="xxl"
      :link="link"
    />
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { getBoostersInHub, removeUserFromHub,searchPeopleOwnersInHub} from '../../api/hubApi'
import Pagination from '../../components/Pagination'
import PlusButtonWithLink from '../../components/PlusButtonWithLink'
import EmptyPage from '../../components/EmptyPage'
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import AlertMessages  from '../../components/AlertMessages'
import ConfirmationDialog from '../../components/ConfirmationDialog'
import SearchBarExpanding from '../../components/SearchBarExpanding'

export default {
    components: {
        Pagination,
        PlusButtonWithLink,
        EmptyPage,
        AlertMessages,
        ConfirmationDialog,
        SearchBarExpanding
    },
    mixins: [repeatedMethodsMixin],
    data(){
        return{
            users: [],
            usersInfo: { 
                currentPage: 1,
                total: 0,
            },
            userId: window.$cookies.get('id'),
            hubId: this.$route.params.id,
            spaceId: window.$cookies.get('space_id'),
            error:'',
            alertMsg:'',
            alertType:'',
            alertValue:false,
            defaultImage: require('../../assets/user_images/profile-avatar.png'),
            pageNumber: 1,
            size: 15,
            loadingData: false,
            dialogVisibleRemoveUser: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            link: {title: i18n.t('invitePeopleTitle'), route: '/hub/' + this.$route.params.id + '/owners/add'},
            search: null,
            isLoading:false,
            paginationKey: '',
            spaceOwnerEmail: localStorage.space ? JSON.parse(localStorage.space).owner_email : '',
            totalUsers: 0
        }
    },
    async created(){
        this.loadingData = true
        await this.fetchOwnersInHub()
        if(this.$route.params.boostersAddedInHub){
            this.alertMsg = i18n.t('addHubBoostersSuccess')
            this.alertType = 'success'
            this.alertValue = true
        }
        this.loadingData = false
    },
    methods:{
        async searchPeople(keyword){
          this.search = keyword
            if(keyword && keyword.trim().length >= 2){
              this.isLoading = true
              try {
                  const response = await searchPeopleOwnersInHub(this.hubId,keyword,this.pageNumber,this.size)
                  if(response){
                      if(response.status == 200){
                        this.users = response.data.data
                        if(this.users.length == 0 && response.data.meta.total > 0){
                            this.pageNumber = 1
                            await this.searchPeople(keyword)
                        }else {
                            this.usersInfo = response.data.meta
                            if(this.pageNumber == 1){
                              this.paginationKey = Date.now()
                            }
                            window.scrollTo(0,0)
                        }
                      }
                  }
              } catch (e) {
                  if(e.response){
                      this.error = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                      this.alertValue = true
                  } 
              }
              this.isLoading = false
            }
            this.isLoading = false
        },
        async resetSearch(){
          this.usersInfo.currentPage = 1
          this.pageNumber = 1
          await this.fetchOwnersInHub()
          this.search=null
          this.paginationKey = Date.now()
          return
        },
         handlePageChange(value){
            this.usersInfo.currentPage = value
            this.pageNumber = value
            if(this.search == null){
              this.fetchOwnersInHub()
            }else {
              this.searchPeople(this.search)
            }
        },
        async fetchOwnersInHub(){
            try {
                const response = await getBoostersInHub(this.hubId, this.pageNumber, this.size)
                if(response.status){
                    if(response.status == 200) {
                        this.users = response.data.data
                        if(this.users.length == 0 && response.data.meta.total > 0){
                            this.pageNumber = 1
                            await this.fetchOwnersInHub()
                        }else {
                            this.usersInfo = response.data.meta
                            this.totalUsers = response.data.meta.total
                            if(this.pageNumber == 1){
                              this.paginationKey = Date.now()
                            }
                            window.scrollTo(0,0)
                        }
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    } else {
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        showHubOverview(){
            if (this.$route.name != 'HubOverview') {
                this.$router.push({path: '/hub/'+ this.hubId +'/overview'})
            }
        },
        showHubMembers(){
            if (this.$route.name != 'PeopleInHub') {
                this.$router.push({path: '/hub/'+ this.hubId +'/people'})
            }
        },
        showHubOwners(){
            if (this.$route.name != 'BoostersInHub') {
                this.$router.push({path: '/hub/'+ this.hubId +'/owners'})
            }
        },
        async removeUser(email){
            this.dialogVisibleRemoveUser = false
            try{
                let data = {
                    data: {
                        type: "hub-users", 
                        attributes: {
                            user_email: email
                        },

                    }
                }
                const response = await removeUserFromHub(this.hubId, data)
                if(response.status == 200) {
                    if(this.search == null){
                        await this.fetchOwnersInHub()
                    }else {
                        await this.searchPeople(this.search)
                    }
                    this.alertValue = true
                    this.alertType = 'success'
                    this.alertMsg =  i18n.t('removeUserFromHubSuccess')
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        },
        goBack(){
            this.$router.push({path: '/hub/'+ this.hubId})
        },
    },
}
</script>
